import React from "react";
import { FaAndroid, FaGlobe, FaShoppingCart, FaUserTie } from "react-icons/fa";
import { MdPublish } from "react-icons/md";

const PublishProduct = () => {
  return (
    <div>
      <div className="text-start">
        <div className="flex items-center gap-4 mb-8">
          <MdPublish className="text-pink-600 text-5xl" />
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900">
            Publish Products
          </h1>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 sm:mb-8 gap-4">
        <div className="flex flex-wrap gap-3">
          {/* Seller Tag */}
          <span className="flex items-center gap-2 bg-green-100 text-green-700 px-4 py-2 rounded-full font-semibold text-sm shadow-sm hover:bg-green-200 transition">
            <FaUserTie className="text-green-600" />
            Seller
          </span>

          {/* Buyer Tag */}
          <span className="flex items-center gap-2 bg-pink-100 text-pink-700 px-4 py-2 rounded-full font-semibold text-sm shadow-sm hover:bg-pink-200 transition">
            <FaShoppingCart className="text-pink-600" />
            Buyer
          </span>
        </div>

        <div className="flex flex-wrap gap-3">
          {/* Web Tag */}
          <span className="flex items-center gap-2 bg-blue-100 text-blue-700 px-4 py-2 rounded-full font-semibold text-sm shadow-sm hover:bg-blue-200 transition">
            <FaGlobe className="text-blue-600" />
            Web
          </span>

          {/* Android Tag */}
          <span className="flex items-center gap-2 bg-green-100 text-green-700 px-4 py-2 rounded-full font-semibold text-sm shadow-sm hover:bg-green-200 transition">
            <FaAndroid className="text-green-600" />
            Android
          </span>
        </div>
      </div>

      <p className="text-start mb-6 text-gray-600 ">
        The publish products feature lets you share updated product information
        with your buyers. Any changes you make in Selzor are not immediately
        visible to them, ensuring incomplete details are never displayed. Once
        all edits are complete and you’re ready, simply publish your products to
        make the updates live for your buyers.
      </p>

      <div className="rounded-lg p-2 sm:p-4 flex justify-start bg-yellow-200">
        <p className="text-start text-sm  text-orange-600 text-orange-600">
          After the first 25 publish attempts, you can publish your data only
          once in 24 hours. Please ensure that you publish your data only after
          reconfirming that all the edits have been done.
        </p>
      </div>
    </div>
  );
};

export default PublishProduct;
